<script>
export default {
  name: "agentImageSection"
};
</script>

<template>
  <el-row style="padding: 20px 0 20px 0; background-color: #2D2D2D">
    <el-col
      :span="24"
      style="display: flex; justify-content: left; align-items: center"
    >
      <span class="search-text" style="z-index: 11">Craig, welcome back!</span>
    </el-col>
  </el-row>
</template>

<style scoped>
.search-text {
  color: #fff;
  text-align: left;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Metropolis-Regular";
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/package/welcomeAgent.vue